module.exports = __webpack_public_path__ + "static/Thumb_Ninjya_comp-0138d99395aaab6426290b4a501f20e9.png";